"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = _interopRequireDefault(require("../modal"));

var _heading = _interopRequireDefault(require("../heading"));

var _useResizeObserver = _interopRequireDefault(require("../../hooks/__internal__/useResizeObserver"));

var _dialog = require("./dialog.style");

var _focusTrap = _interopRequireDefault(require("../../__internal__/focus-trap"));

var _iconButton = _interopRequireDefault(require("../icon-button"));

var _icon = _interopRequireDefault(require("../icon"));

var _form = _interopRequireDefault(require("../form"));

var _dialog2 = require("./dialog.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Dialog = ({
  className,
  children,
  open,
  height,
  size,
  ariaRole,
  title,
  disableEscKey,
  subtitle,
  disableAutoFocus,
  focusFirstElement,
  onCancel,
  showCloseIcon,
  bespokeFocusTrap,
  disableClose,
  help,
  ...rest
}) => {
  const dialogRef = (0, _react.useRef)();
  const innerContentRef = (0, _react.useRef)();
  const titleRef = (0, _react.useRef)();
  const listenersAdded = (0, _react.useRef)(false);
  const centerDialog = (0, _react.useCallback)(() => {
    const {
      width: dialogWidth,
      height: dialogHeight
    } = dialogRef.current.getBoundingClientRect();
    let midPointY = window.innerHeight / 2;
    let midPointX = window.innerWidth / 2;
    midPointY -= dialogHeight / 2;
    midPointX -= dialogWidth / 2;

    if (midPointY < _dialog2.TOP_MARGIN) {
      midPointY = _dialog2.TOP_MARGIN;
    }

    if (midPointX < _dialog2.TOP_MARGIN) {
      midPointX = _dialog2.TOP_MARGIN;
    }

    dialogRef.current.style.top = `${midPointY}px`;
    dialogRef.current.style.left = `${midPointX}px`;
  }, []);
  (0, _useResizeObserver.default)(innerContentRef, centerDialog, !open);
  const addListeners = (0, _react.useCallback)(() => {
    /* istanbul ignore else */
    if (!listenersAdded.current) {
      window.addEventListener("resize", centerDialog);
      listenersAdded.current = true;
    }
  }, [centerDialog]);
  const removeListeners = (0, _react.useCallback)(() => {
    if (listenersAdded.current) {
      window.removeEventListener("resize", centerDialog);
      listenersAdded.current = false;
    }
  }, [centerDialog]);
  (0, _react.useEffect)(() => {
    if (open) {
      addListeners();
    }

    if (!open) {
      removeListeners();
    }

    return () => {
      removeListeners();
    };
  }, [open, addListeners, removeListeners]);
  (0, _react.useLayoutEffect)(() => {
    if (open) {
      centerDialog();
    }
  }, [centerDialog, open, height]);

  const closeIcon = () => {
    if (!showCloseIcon || !onCancel) return null;
    return /*#__PURE__*/_react.default.createElement(_iconButton.default, {
      "data-element": "close",
      "aria-label": "Close button",
      onAction: onCancel,
      disabled: disableClose
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "close"
    }));
  };

  const dialogTitle = () => {
    if (!title) return null;
    return /*#__PURE__*/_react.default.createElement(_dialog.DialogTitleStyle, {
      showCloseIcon: showCloseIcon,
      hasSubtitle: !!subtitle,
      ref: titleRef
    }, typeof title === "string" ? /*#__PURE__*/_react.default.createElement(_heading.default, {
      title: title,
      titleId: "carbon-dialog-title",
      subheader: subtitle,
      subtitleId: "carbon-dialog-subtitle",
      divider: false,
      help: help
    }) : title);
  };

  let dialogHeight = height;

  if (height && height.match(/px$/)) {
    dialogHeight = height.replace("px", "");
  }

  const dialogProps = {
    size,
    dialogHeight
  };
  if (ariaRole) dialogProps.role = ariaRole;
  if (title) dialogProps["aria-labelledby"] = "carbon-dialog-title";
  if (subtitle) dialogProps["aria-describedby"] = "carbon-dialog-subtitle";
  const componentTags = {
    "data-component": rest["data-component"] || "dialog",
    "data-element": rest["data-element"],
    "data-role": rest["data-role"]
  };
  return /*#__PURE__*/_react.default.createElement(_modal.default, _extends({
    open: open,
    onCancel: onCancel,
    disableEscKey: disableEscKey,
    disableClose: disableClose,
    className: className ? `${className} carbon-dialog` : "carbon-dialog"
  }, componentTags), /*#__PURE__*/_react.default.createElement(_focusTrap.default, {
    autoFocus: !disableAutoFocus,
    focusFirstElement: focusFirstElement,
    bespokeTrap: bespokeFocusTrap,
    wrapperRef: dialogRef
  }, /*#__PURE__*/_react.default.createElement(_dialog.DialogStyle, _extends({
    ref: dialogRef,
    topMargin: _dialog2.TOP_MARGIN
  }, dialogProps, {
    "data-component": "dialog",
    "data-element": "dialog",
    "data-role": rest["data-role"]
  }), dialogTitle(), /*#__PURE__*/_react.default.createElement(_dialog.DialogContentStyle, null, /*#__PURE__*/_react.default.createElement(_dialog.DialogInnerContentStyle, {
    ref: innerContentRef
  }, _react.default.Children.map(children, child => {
    if ((child === null || child === void 0 ? void 0 : child.type) === _form.default) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        dialogRef
      });
    }

    return child;
  }))), closeIcon())));
};

Dialog.propTypes = {
  /**
   * The ARIA role to be applied to the Dialog
   * @ignore
   * @private
   */
  ariaRole: _propTypes.default.string,

  /** Dialog content */
  children: _propTypes.default.node,

  /** Custom classname  */
  className: _propTypes.default.string,

  /** Controls the open state of the component */
  open: _propTypes.default.bool.isRequired,

  /** A custom close event handler */
  onCancel: _propTypes.default.func,

  /** Determines if the Esc Key closes the Dialog */
  disableEscKey: _propTypes.default.bool,

  /** Determines if the Dialog can be closed */
  disableClose: _propTypes.default.bool,

  /** Allows developers to specify a specific height for the dialog. */
  height: _propTypes.default.string,

  /** Adds Help tooltip to Header */
  help: _propTypes.default.string,

  /** Title displayed at top of dialog */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /** Subtitle displayed at top of dialog */
  subtitle: _propTypes.default.string,

  /** Size of dialog, default size is 750px */
  size: _propTypes.default.oneOf(["auto", "extra-small", "small", "medium-small", "medium", "medium-large", "large", "extra-large"]),

  /** Determines if the close icon is shown */
  showCloseIcon: _propTypes.default.bool,

  /** Optional reference to an element meant to be focused on open */
  focusFirstElement: _propTypes.default.shape({
    current: _propTypes.default.any
  }),

  /** Disables auto focus functionality on child elements */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * Function to replace focus trap
   * @ignore
   * @private
   */
  bespokeFocusTrap: _propTypes.default.func
};
Dialog.defaultProps = {
  size: "medium",
  showCloseIcon: true,
  ariaRole: "dialog",
  disableAutoFocus: false
};
var _default = Dialog;
exports.default = _default;